import {css} from "@emotion/css";

import {designColors} from "~/ui";
import {getHoverColor} from "~/utils/colors";

export const styles = {
  errorButton: css`
    &.MuiButton-root {
      &,
      &:hover,
      &:active {
        box-shadow: 0px 2px 0px 0px rgba(183, 35, 34, 0.33);
      }

      color: ${designColors.red_3};
      background-color: ${designColors.red_1};

      &.Mui-focusVisible {
        box-shadow:
          0px 2px 0px 0px rgba(183, 35, 34, 0.33),
          inset 0 0 0 2px ${designColors.blue_3};
      }
      &.Mui-disabled {
        color: ${designColors.red_3};
        background-color: ${designColors.red_1};

        opacity: 0.4;

        box-shadow: 0px 2px 0px 0px rgba(183, 35, 34, 0.33);
      }

      &.MuiLoadingButton-loading {
        min-width: 100px;
      }
      &.MuiLoadingButton-loading .MuiCircularProgress-svg circle {
        stroke: ${designColors.error};
      }
    }

    & .MuiTouchRipple-root span {
      background-color: ${getHoverColor(designColors.red_1, "lighter")};
      border-radius: 50%;

      opacity: 1 !important;
    }
  `,
};
